import * as React from 'react';

export const ParallaxSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="45" viewBox="0 0 48 45"><g transform="translate(-55.795 -32.871)"><g transform="translate(55.795 32.871)" fill="#fff" stroke="#041156" strokeWidth="1.6"><rect width="37" height="36" rx="2" stroke="none"/><rect x="0.8" y="0.8" width="35.4" height="34.4" rx="1.2" fill="none"/></g><g transform="translate(68.795 41.871)" fill="#ffd803" stroke="#041156" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><rect width="35" height="36" rx="2" stroke="none"/><rect x="1" y="1" width="33" height="34" rx="1" fill="none"/></g></g></svg>
  );
};
